module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_14.bf450ab8dac48db9e61d9d74cc5390ac.png";